import type { FC } from "react";
import MetaChip from "../../../../components/UIToolkit/Badges/MetaChip";
import { ColorDot } from "../../../../components/UIToolkit/molecules/ColorDot";
import { useRoleColors } from "../../../../hooks/useRoleColors";
import type { NurseFullRole } from "../../../../utils/models";
import { getShortRole } from "../../../../utils/utilFunctions";

/**
 * A role as a short chip ("RN") whose categorical colour rides on a dot, as job chips do — the lighter role
 * hues wash out as a fill. `MetaChip` rather than `ColorfulRole` because it renders as a `<span>`, and it has
 * to sit inside a pick-list row's `<button>`.
 */
export const MergeRoleChip: FC<{ role: string }> = ({ role }) => {
	const roleColor = useRoleColors();
	// The merge endpoints send the stored role string, which is a NurseFullRole value ("Registered Nurse (RN)").
	const fullRole = role as NurseFullRole;
	return <MetaChip label={getShortRole(fullRole)} icon={<ColorDot color={roleColor(fullRole).dot} />} tone="neutral" tooltip={role} />;
};
